<template>
    <div>
        <h1>Clock In/Out IPs</h1>
        <form @submit.prevent="runReport">
            <Options />
            <Results />
        </form>
    </div>
</template>

<script>
    import { store } from '@/store/Report.store.js';
    import Options from './clock_in_out_ips_opt'
    import Results from "./utils/Results";

    export default {
        name: 'clock_in_out_ips',
        components: {
            Options,
            Results
        },
        data() {
            return {
                state: store.state,
                optionFields: {
                    fromDate: {val: new Date().toLocaleDateString(), qsField: '[datetimes][clock_time_from]'},
                    toDate: {val: new Date().toLocaleDateString(), qsField: '[datetimes][clock_time_to]'},
                    employee: {val: '',},
                    employeeID: {val: '', qsField: '[numbers][u.user_id]'},
                    cdiLocationID: {val: '0', qsField: '[numbers][cdi_location_id]'},
                    ipNotCdi: {val: null, qsField: '[isset][flagged]'}
                },
                groupByFields: {},
                dataFields: {}
            }
        },
        methods: {
            runReport: function() {
                store.runReport();
            }
        },
        created() {
            this.$appStore.setTitle(['Clock In/Out IPs']);
            this.$set(store.state.results, this.$options.name, '');
            store.setReport(this.$options.name, this.optionFields, this.groupByFields, this.dataFields);
        }
    }
</script>
